import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const { NEW_DOCUMENT_SIGN_SUCCESS, NEW_DOCUMENT_SIGN_REQUEST, NEW_DOCUMENT_SIGN_FAILURE } =
  documentationActions;

function* newDocumentSign(action: any): SagaReturnType<any> {
  try {
    const response = yield call(templateService.newDocSignatureFlow, action.payload);
    if (response?.status === 200) {
      yield put({ type: NEW_DOCUMENT_SIGN_SUCCESS, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: NEW_DOCUMENT_SIGN_FAILURE, payload: error });
  }
}

function* newDocumentSignSaga() {
  yield takeEvery(NEW_DOCUMENT_SIGN_REQUEST, newDocumentSign);
}

export default newDocumentSignSaga;
